import client from "./client";

const inFlightVisitorTracks = new Map();

export function trackPortalVisitor(payload) {
  const key = JSON.stringify({
    visitorId: String(payload?.visitorId || ""),
    pagePath: String(payload?.pagePath || ""),
    referrer: String(payload?.referrer || ""),
  });
  const current = inFlightVisitorTracks.get(key);
  if (current) return current;

  const request = client.post("/website/visitors/track", payload);
  inFlightVisitorTracks.set(key, request);
  const release = () => {
    if (inFlightVisitorTracks.get(key) === request) {
      inFlightVisitorTracks.delete(key);
    }
  };
  request.then(release, release);
  return request;
}

export function __resetVisitorTrackDedupeForTests() {
  inFlightVisitorTracks.clear();
}
